import { fireEvent, render, screen } from '@testing-library/react'
import { MemoryRouter } from 'react-router-dom'
import Navigation from './Navigation'

describe('Navigation', () => {
  test('groups the association pages in a dropdown', () => {
    render(
      <MemoryRouter initialEntries={['/ejes']}>
        <Navigation />
      </MemoryRouter>
    )

    const associationLink = screen.getByRole('link', { name: 'Asociación' })
    const associationToggle = screen.getByRole('button', { name: 'Abrir menú de Asociación' })

    expect(associationLink.getAttribute('href')).toBe('/asociacion')
    expect(associationToggle.classList.contains('btn-primary')).toBe(false)
    expect(screen.queryByText('▾')).toBeNull()
    fireEvent.click(associationToggle)

    const aboutLink = screen.getByRole('link', { name: 'Conócenos' })

    expect(aboutLink.getAttribute('href')).toBe('/conocenos')
    expect(screen.queryByRole('link', { name: 'Memoria' })).toBeNull()
    expect(associationLink.classList.contains('active')).toBe(false)

    const whatWeDoLink = screen.getByRole('link', { name: 'Qué hacemos' })

    expect(whatWeDoLink.getAttribute('href')).toBe('/que-hacemos')
    expect(screen.queryByRole('button', { name: 'Abrir menú de Qué hacemos' })).toBeNull()

    const ubTrainingLinks = screen.getAllByRole('link', { name: 'Formación UB' })
    expect(ubTrainingLinks).toHaveLength(1)
    ubTrainingLinks.forEach((link) => {
      expect(link.getAttribute('href')).toBe('/formacion-ub')
    })

    const linkHrefs = screen.getAllByRole('link').map((link) => link.getAttribute('href'))
    const publicationIndex = linkHrefs.indexOf('/publicaciones')
    const trainingIndexes = linkHrefs.reduce((indexes, href, index) => (
      href === '/formacion-ub' ? [...indexes, index] : indexes
    ), [])
    const friendsIndex = linkHrefs.indexOf('/hazte-amiga')
    const primaryTrainingIndex = trainingIndexes[trainingIndexes.length - 1]

    expect(primaryTrainingIndex).toBe(publicationIndex + 1)
    expect(friendsIndex).toBe(primaryTrainingIndex + 1)
  })
})
